import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import GooglePlay from "./googlePlay";
import AppStore from "./appStore";
import Exe from "./exe";
import Url from "./url";
import useTheme from "../../hooks/useTheme";
import { PlatformType, SupportedType } from "../../types/types";

export default function Platform(props: {
  platforms: SupportedType[];
  style?: React.CSSProperties;
}) {
  const { isSmallLayout, isMediumLayout } = useWindowDimensions();
  const theme = useTheme();

  const styles: {
    platformStyle: React.CSSProperties;
  } = {
    platformStyle: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0px 4px 0px 4px",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        paddingTop: isSmallLayout || isMediumLayout ? 5 : 0,
        paddingBottom: isSmallLayout || isMediumLayout ? 2 : 0,
        ...props.style,
      }}
    >
      {props.platforms.map((item: SupportedType) => {
        if (item.link !== undefined)
          return (
            <a
              key={item.link}
              href={item.link}
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: "none",
                color: theme.textColor,
                fontSize: isSmallLayout ? 14 : 16,
                textAlign: "center",
              }}
            >
              <div>
                {item.platform === PlatformType.android && (
                  <GooglePlay style={styles.platformStyle} store={true} />
                )}
                {item.platform === PlatformType.iOS && (
                  <AppStore style={styles.platformStyle} store={true} />
                )}
                {item.platform === PlatformType.windows && (
                  <Exe
                    style={styles.platformStyle && { margin: 2 }}
                    store={true}
                  />
                )}
                {item.platform === PlatformType.web && (
                  <Url
                    style={styles.platformStyle && { margin: 2 }}
                    store={true}
                  />
                )}
              </div>
            </a>
          );
        else return null;
      })}
    </div>
  );
}
